import {
  Component,
  effect,
  inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { GlobalSearchStore } from '../../../stores/global-search.state';
import { GlobalsStore } from '../../../stores/globals.state';
import { AlertComponent } from '../../atoms/alert/alert.component';
import { BadgeModule } from 'primeng/badge';
import { Button, ButtonDirective } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { KeyComboButtonComponent } from '../../atoms/key-combo-button/key-combo-button.component';
import { NgClass, NgIf } from '@angular/common';
import { MenuItem, PrimeTemplate } from 'primeng/api';
import { Ripple } from 'primeng/ripple';
import { SearchInputComponent } from '../../atoms/search-input/search-input.component';
import { TabMenuModule } from 'primeng/tabmenu';
import { TableModule } from 'primeng/table';
import { TableRowBookmarkComponent } from '../../atoms/table-row-bookmark/table-row-bookmark.component';
import { TableRowDataLayerTypeComponent } from '../../atoms/table-row-data-layer-type/table-row-data-layer-type.component';
import { TableRowIndicatorComponent } from '../../atoms/table-row-indicator/table-row-indicator.component';
import { TableRowStoryComponent } from '../../atoms/table-row-story/table-row-story.component';
import { TableRowTopicComponent } from '../../atoms/table-row-topic/table-row-topic.component';
import { Indicator } from '../../../models/indicator';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { HeaderComponent } from '../../atoms/header/header.component';
import { TypeDropdownComponent } from '../../atoms/type-dropdown/type-dropdown.component';
import { DataLayerType } from '../../../models/data-layer-type';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WidgetStore } from '../../../stores/grid/widget.state';
import { getState } from '@ngrx/signals';
import { TagFilterDropdownComponent } from '../../atoms/tag-filter-dropdown/tag-filter-dropdown.component';
import { AtlasIndicatorTreeComponent } from '../atlas-indicator-tree/atlas-indicator-tree.component';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { IndicatorStore } from '../../../stores/indicator/indicator.state';
import { TableRowDistrictComponent } from '../../atoms/table-row-district/table-row-district.component';
import { IndicatorSelectionListComponent } from '../../molecules/indicator-selection-list/indicator-selection-list.component';
import { DividerModule } from 'primeng/divider';
import { TreeSelectModule } from 'primeng/treeselect';
import { CategoryStore } from '../../../stores/category/category.state';
import { Category } from '../../../models/category';
import { StyleClassModule } from 'primeng/styleclass';
import { IndicatorTreeHelperService } from '../../../indicator-tree-helper.service';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { IndicatorDataStore } from '../../../stores/indicatpr-data/indicator-data.state';
import { CustomGridStackWidget } from '../../../services/grid-widget-config.service';
import { DataLayerStore } from '../../../stores/data-layer/data-layer.state';
import { MenuModule } from 'primeng/menu';
import { getOSKeyLabel } from '../../../utility/os-detection';

@Component({
  selector: 'app-atlas-search',
  standalone: true,
  imports: [
    AlertComponent,
    BadgeModule,
    Button,
    DialogModule,
    KeyComboButtonComponent,
    NgIf,
    PrimeTemplate,
    Ripple,
    SearchInputComponent,
    TabMenuModule,
    TableModule,
    TableRowBookmarkComponent,
    TableRowDataLayerTypeComponent,
    TableRowIndicatorComponent,
    TableRowStoryComponent,
    TableRowTopicComponent,
    ButtonDirective,
    ConfirmDialogModule,
    HeaderComponent,
    TypeDropdownComponent,
    FormsModule,
    TagFilterDropdownComponent,
    AtlasIndicatorTreeComponent,
    ScrollPanelModule,
    TableRowDistrictComponent,
    IndicatorSelectionListComponent,
    DividerModule,
    NgClass,
    ReactiveFormsModule,
    TreeSelectModule,
    StyleClassModule,
    IconFieldModule,
    InputIconModule,
    MenuModule,
  ],
  templateUrl: './atlas-search.component.html',
  styleUrl: './atlas-search.component.scss',
})
export class AtlasSearchComponent implements OnInit, OnDestroy {
  readonly globalSearchStore = inject(GlobalSearchStore);
  readonly globalStore = inject(GlobalsStore);
  readonly categoryStore = inject(CategoryStore);
  readonly indicatorStore = inject(IndicatorStore);
  readonly layerStore = inject(DataLayerStore);
  readonly dataStore = inject(IndicatorDataStore);
  readonly widgetStore = inject(WidgetStore);
  readonly shortcutModifierLabel = getOSKeyLabel('control');

  @ViewChild(SearchInputComponent) searchInputComponent!: SearchInputComponent;

  visible: any;
  active = 'all';
  results?: { [key: string]: any[] };
  indicatorSelection: string[] = [];
  showGenerateViewDialog = false;
  showGenerateViewMode: 'indicator' | 'dataLayerType' = 'indicator';
  dataLayerTypeToGenerateView: DataLayerType | null = null;
  hasDataWidgets = false;
  markDistrict?: string = undefined;
  generatePoiDataView: false | string = false;

  // search parameter
  queryString = '';
  queryTags: string[] = [];
  queryCategory: Category | null = null;
  tree: any;

  tabs: MenuItem[] = [
    {
      label: 'Alle Ergebnisse',
      key: 'all',
      icon: 'fas fa-shuffle',
      command: event => {
        this.active = 'all';
      },
    },
    {
      label: 'Indikatoren',
      key: 'indicators',
      icon: 'fas fa-ruler-vertical',
      command: event => {
        this.active = 'indicators';
      },
    },
    {
      label: 'Räume',
      key: 'dataLayerTypes',
      icon: 'fa-regular fa-map',
      command: event => {
        this.active = 'dataLayerTypes';
      },
    },
    {
      label: 'Teilräume',
      key: 'districts',
      icon: 'fas fa-thumb-tack',
      command: event => {
        this.active = 'districts';
      },
    },
    {
      label: 'Standorte',
      key: 'poiLayerTypes',
      icon: 'fas fa-map-location-dot',
      command: event => {
        this.active = 'poiLayerTypes';
      },
    },
    {
      label: 'Standorte (einzeln)',
      key: 'pois',
      icon: 'fas fa-location-dot',
      command: event => {
        this.active = 'pois';
      },
    },
    {
      label: 'Ansichten',
      key: 'bookmarks',
      icon: 'fas fa-note-sticky',
      command: event => {
        this.active = 'bookmarks';
      },
    },
    {
      label: 'Berichte',
      key: 'stories',
      icon: 'fas fa-file-lines',
      command: event => {
        this.active = 'stories';
      },
    },
    {
      label: 'Themen',
      key: 'topics',
      icon: 'fas fa-book-open',
      command: event => {
        this.active = 'topics';
      },
    },
  ];
  activeTab: MenuItem = this.tabs[0];

  constructor(private treeHelper: IndicatorTreeHelperService) {
    effect(() => {
      const widgetState = getState(this.widgetStore);
      const globalState = getState(this.globalStore);
      this.hasDataWidgets = this.widgetStore.hasDataWidget();
      if (globalState.atlasEventCallback?.key === 'openSearch') {
        this.visible = true;
      }
    });
  }

  /**
   * Lifecycle hook that is called after data-bound properties of a directive are initialized.
   * It organizes category data into a tree structure and filters it based on associated indicators.
   *
   * Groups indicators by category using the `indicatorStore`, initializes a category tree using the
   * `categoryStore`, and filters the tree to only include categories that have associated indicators.
   * If a valid initial category tree is available, the filtering operation is delayed using a setTimeout.
   *
   * @return {void} This method does not return a value.
   */
  ngOnInit(): void {
    const groupedIndicators = this.indicatorStore.groupedByCategory();
    const initialCategoryTree = this.categoryStore.asTree();
    if (initialCategoryTree && initialCategoryTree.length) {
      setTimeout(() => {
        this.tree = this.treeHelper.filterCategoriesWithIndicators(
          initialCategoryTree,
          groupedIndicators
        );
      });
    }
  }

  setFocus() {
    this.searchInputComponent.focus();
  }

  isType(type: string, id: string) {
    return this.globalSearchStore.isType(type, id);
  }

  /**
   * Handles the change of the active item in the menu.
   *
   * @param {MenuItem} event - The menu item that triggered the change.
   * @return {void} Does not return any value.
   */
  onActiveItemChange(event: MenuItem) {
    this.activeTab = event;
    this.active = this.activeTab['key'];
  }

  /**
   * Updates the query string with the provided text and triggers a search operation.
   *
   * @param {string} text - The new query string to update.
   * @return {void}
   */
  updateQueryString(text: string): void {
    this.queryString = text;
    this.search();
  }

  /**
   * Updates the queryTags property with the provided tags array and triggers a search operation.
   *
   * @param {string[]} [tags] - An optional array of tags to update. If not provided, the queryTags will be set to an empty array.
   * @return {void}
   */
  updateQueryTags(tags?: string[]): void {
    this.queryTags = tags || [];
    this.search();
  }

  /**
   * Resets the current query state by clearing the query string and query tags.
   * Also triggers a new search with the cleared query state.
   *
   * @return {void} Does not return any value.
   */
  resetQuery(): void {
    this.queryString = '';
    this.queryTags = [];
    this.queryCategory = null;
    this.indicatorStore.updateFilter({ category: [] });
    this.markDistrict = undefined;
    this.generatePoiDataView = false;

    this.search();
  }

  /**
   * Executes a search operation based on the query string and tags.
   * Updates the results and active tab according to the provided search criteria.
   * If both query string and tags are empty, it retrieves the filtered results
   * without applying additional filters.
   *
   * @return {void} No value is returned by this method.
   */
  search(): void {
    this.globalSearchStore.updateQuery(this.queryString, this.queryTags, true);
    if (!this.queryString && !this.queryTags.length) {
      this.results = this.globalSearchStore.filteredResults();
    } else {
      this.results = this.globalSearchStore.filteredResults();
    }
    //this.setActiveTab();
  }

  /**
   * Sets the active tab by iterating through the available tabs and finding the first tab
   * with a valid key and corresponding non-empty results. Updates the `active` and `activeTab`
   * properties accordingly.
   *
   * @return {void} Does not return a value.
   */
  setActiveTab(): void {
    for (const idx in this.tabs) {
      const tab = this.tabs[idx];
      const tabKey = tab['key'];

      if (
        tabKey &&
        this.results &&
        this.results[tabKey] &&
        this.results[tabKey].length
      ) {
        this.active = tabKey;
        this.activeTab = tab;
        break;
      }
    }
  }

  /**
   * Adds an indicator to the selection.
   *
   * @param {string} indicator - The indicator to add to the selection.
   * @return {void} This method does not return a value.
   */
  addToSelection(indicator: string): void {
    if (this.indicatorSelection.includes(indicator)) {
      this.removeFromSelection(indicator);
    } else {
      this.indicatorSelection.push(indicator);
    }
  }

  /**
   * Removes the specified indicator from the current selection.
   *
   * @param {string} indicator - The indicator to be removed from the selection.
   * @return {void}
   */
  removeFromSelection(indicator: string): void {
    this.indicatorSelection.splice(
      this.indicatorSelection.indexOf(indicator),
      1
    );
  }

  /**
   * Clears the current selection by resetting the indicatorSelection property to an empty array.
   *
   * @return {void} This method does not return a value.
   */
  resetFromSelection(): void {
    this.indicatorSelection = [];
  }

  /**
   * Closes the current process or visibility related to the component.
   * Resets specific settings such as visibility and indicator selection.
   * Ensures the component is no longer active or displayed.
   *
   * @return {void} No value is returned.
   */
  close(): void {
    //this.results = undefined; // show all when not searched
    this.visible = false;
    this.indicatorSelection = [];
  }

  /**
   * Adds the specified indicator to the widgets and triggers an Atlas event.
   *
   * @param {Indicator} indicator - The indicator to be added to the widgets.
   * @return {void} No return value.
   */
  addToWidgets(indicator: Indicator): void {
    this.globalStore.triggerAtlasEvent('addToWidgets', {
      indicatorIds: [indicator._id],
    });
    this.close();
  }

  /**
   * Initializes the view dialog based on the provided parameters. Configures the dialog behavior
   * depending on the indicator, data layer type, district, or point of interest provided.
   *
   * @param {Indicator} [indicator] - The indicator to be added to the indicator selection. When provided, sets the mode to 'indicator' and opens the generate view dialog.
   * @param {DataLayerType} [dataLayerType] - The data layer type to be set for generating the view. Checks if the data layer type has data, then sets the mode to 'dataLayerType' and opens the generate view dialog.
   * @param {string} [districtToMark] - A specific district to highlight or mark in the view. Currently not used in the method implementation.
   * @param {string} [poi] - A specific point of interest to handle. When provided, triggers the view generation with a non-data configuration template.
   * @return {void} Does not return any value.
   */
  initViewDialog(
    indicator?: Indicator,
    dataLayerType?: DataLayerType,
    districtToMark?: string,
    poi?: string
  ): void {
    this.markDistrict = String(districtToMark) || undefined;
    if (indicator) {
      this.indicatorSelection.push(indicator._id);
      this.showGenerateViewMode = 'indicator';
      this.showGenerateViewDialog = true;
    } else if (!dataLayerType && this.indicatorSelection.length > 0) {
      this.showGenerateViewMode = 'indicator';
      this.showGenerateViewDialog = true;
    }

    if (dataLayerType) {
      if (this.dataStore.dataLayerTypeHasData(dataLayerType._id)) {
        this.dataLayerTypeToGenerateView = dataLayerType;
        this.showGenerateViewMode = 'dataLayerType';
        this.showGenerateViewDialog = true;
      }
    }

    if (!this.showGenerateViewDialog && poi) {
      this.generateNoneDataView(poi);
    } else if (poi) {
      this.generatePoiDataView = poi;
    }
  }

  generateNoneDataView(poi: string): void {
    this.generateView(this.getNoneDataConfigTemplate(poi));
  }

  /**
   * Generates and returns a configuration template for a non-data-based widget configuration.
   *
   * @return {Array} An array containing the configuration template object for non-data-based widgets.
   */
  getNoneDataConfigTemplate(poi: string): CustomGridStackWidget[] {
    const mapBase = this.widgetStore.initializeConfig('map');

    mapBase.widget.dataLayerType = poi;
    mapBase.widget.dataLayer = (
      this.layerStore.getLatestNonForecastByParent(poi) ??
      this.layerStore.getLatestByParent(poi)
    )._id;
    mapBase.w = 12;
    mapBase.h = 4;

    return [mapBase];
  }

  /**
   * Closes the Atlas dialog by hiding the dialog view.
   *
   * @return {void} No return value.
   */
  closeAtlasDialog(): void {
    this.showGenerateViewDialog = false;
  }

  /**
   * Triggers the generation of a view based on the provided data layer type and selected indicators.
   * If the required data layer type is not available, the method exits without performing any actions.
   * Internally, emits an event to indicate the generation of the view and updates the necessary attributes.
   *
   * @return {void} Does not return any value.
   */
  generateView(template?: Partial<CustomGridStackWidget>[]): void {
    console.log('template', template);
    if (this.markDistrict) {
      setTimeout(() => {
        this.globalStore.triggerAtlasEvent('markDistrict', {
          key: this.markDistrict,
        });
      }, 300);
    }

    this.globalStore.triggerAtlasEvent('generateView', {
      indicatorIds: this.indicatorSelection || [],
      dataLayerTypeId:
        template?.[0]?.widget?.dataLayerType ||
        this.dataLayerTypeToGenerateView?._id ||
        '',
      template: template,
    });
    this.showGenerateViewDialog = false;
    this.close();
  }

  /**
   * Handles the category search functionality by updating the filter with the selected category
   * and triggering the search operation.
   *
   * @param {any} event - The event object containing information about the selected category,
   *                      specifically the node key representing the category.
   * @return {void} This method does not return a value.
   */
  callCategorySearch(event?: any): void {
    if (event) {
      this.indicatorStore.updateFilter({
        category: this.categoryStore
          .fetchCategoryChildren(event.node.key)
          .map(item => item._id)
          .concat(event.node.key),
      });

      this.activeTab = this.tabs[0];
      this.active = this.activeTab['key'];
    } else {
      this.indicatorStore.updateFilter({ category: [] });
    }

    queueMicrotask(() => this.search());
  }

  /**
   * Lifecycle hook that is called when the component is about to be destroyed.
   * Performs necessary cleanup such as resetting the query state.
   *
   * @return {void} Does not return any value.
   */
  ngOnDestroy(): void {
    this.resetQuery();
    this.close();
  }
}
